import React from "react";
import "../CSS file/applicationcontent.css";
import "../CSS file/visacontent.css";
import { BiLoader } from "react-icons/bi";
const clg_img = require("../../assets/clg_profile_pic.png");

function VisaContent(props) {
  const allDataOfVisaAplication = [
    {
      universityImage: clg_img,
      universityName: `University of alberta `,
      universityDate: `Aug 2022`,
      countryName: `Canada`,
      courseName: `MBA Business and Management`,
      stageName: `Application Fee Pending`,
    },
    {
      universityImage: clg_img,
      universityName: `University of alberta `,
      universityDate: `Aug 2022`,
      countryName: `Canada`,
      courseName: `MBA Business and Management`,
      stageName: `Application Fee Pending`,
    },
  ];

  const renderVisaApplication = allDataOfVisaAplication.map((perVisa) => {
    return (
      <tr className="data_table_content" key={Math.random()}>
        <td className="data_content_container">
          <div className="clg_img_container_circle">
            <img
              src={perVisa.universityImage}
              alt="clg_pic"
              className="clg_img_self"
              loading="lazy"
            />
          </div>
          <div className="univ_date_container">
            <p className="univ_title_text">{perVisa.universityName}</p>
            <p className="date_text_">Starting :{perVisa.universityDate} </p>
          </div>
        </td>
        <td>
          <p className="stage_text">{perVisa.courseName}</p>
        </td>
        <td>
          <p className="stage_text">{perVisa.countryName}</p>
        </td>
        <td>
          <div className="icon_progress_text">
            <BiLoader className="yellow_color_text icon_" />{" "}
            <p className="progress_text yellow_color_text">In Progress</p>
          </div>
        </td>
        <td>
          <p className="stage_text">{perVisa.stageName}</p>
        </td>
        <td>
          <button className="view_btn_container">View</button>
        </td>
      </tr>
    );
  });
  return (
    <div className="application_content_box_container">
      <div className="application_main_content_table">
        <table className="heading_container_visa">
          <tr className="data_table_content">
            <th className="heading_container_width">University</th>
            <th className="heading_container_width">Course</th>
            <th className="heading_container_width1">Country</th>
            <th className="heading_container_width">Status</th>
            <th className="heading_container_width">Stage</th>
            <th className="heading_container_width1">Action</th>
          </tr>
          {renderVisaApplication}
        </table>
      </div>
    </div>
  );
}

export default VisaContent;
